// @ts-strict-ignore
import { AppRouterInstance } from 'next/dist/shared/lib/app-router-context.shared-runtime'

/**
 * A function that changes the page number in the URL.
 * @param router - object for working with routing
 * @param nextPage - number of the next page
 * @param shallow - flag responsible for redrawing the page when changing the page parameter in the url
 * @param preventScroll
 * */
export const changeRouterPage = async (
	router: AppRouterInstance,
	nextPage: number,
	_shallow = false,
	preventScroll = false
) => {
	const url = new URL(window.location.href)
	url.searchParams.set('page', nextPage.toString())

	const updatedAsPath = preventScroll
		? url.pathname + '?' + url.searchParams.toString()
		: url.pathname + '?' + url.searchParams.toString() + '#catalog-listing'

	await router.push(updatedAsPath, { scroll: !preventScroll })
}
